import { useTranslation } from "react-i18next";
import * as S from "./styles";
import { FooterWithButtons } from "pages/Checkin/components/FooterWithButtons";
import { useEffect, useState } from "react";
import { useSessionStorage } from "context/sessionStorage";
import { useNavigate } from "react-router-dom";
import DropdownCheckin from "pages/Checkin/components/Dropdown";

const PlusIcon = require("assets/svg/Plus.svg").default

interface AddAccompanyingProps {
    birthDate: string;
    documentNumber: string
    documentType: string;
    email: string;
    name: string;
    phone: string;
    surname: string;

}

const editIcon = require("assets/svg/spaceUser/PencilSimple.svg").default
const deleteIcon = require("assets/svg/spaceUser/TrashRed.svg").default

export const Accompanying = () => {
    const { t } = useTranslation();
    const [maxAccompanying, setMaxAccompanying] = useState(0);

    const [users, setUsers] = useState<AddAccompanyingProps[]>([])

    const pathnameActual: string = window.location.pathname.endsWith('/') ? window.location.pathname.slice(0, -1) : window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/'));

    const { getFromSessionStorage, saveToSessionStorage } = useSessionStorage()

    useEffect(() => {
        const maxAccompanyingData = getFromSessionStorage('checkin-details')
        const data = getFromSessionStorage('accompanying')
        if (data) {
            setUsers(data)
        }
        if (maxAccompanyingData) {
            setMaxAccompanying(Number(maxAccompanyingData.max_accompanying))
        }
    }, [])

    const navigate = useNavigate();

    const handleNextStep = () => {
        navigate(`${pathnameActual}/arrival-and-departure`)
    }

    const handleBackStep = () => {
        navigate(`${pathnameActual}/selfie-validation`)
    }

    const handleAddAccompanying = () => {
        if (maxAccompanying > users.length) {
            navigate(`${pathnameActual}/add-accompanying`)
        }
    }

    const handleDeleteAccompanying = (index: number) => {
        const newUsers = users.filter((user, i) => i !== index)
        setUsers(newUsers)
        saveToSessionStorage('accompanying', newUsers)
    }

    const handleEditAccompanying = (index: number) => {
        navigate(`${pathnameActual}/edit-accompanying/${index + 1}`)
    }

    return (
        <S.AccompanyingContainer>
            <h1>{t('checkin.accompanying.title')}</h1>
            <S.ExplainContainer>
                <strong>{t('checkin.accompanying.subtitle')}</strong>

            </S.ExplainContainer>
            <S.ContainerDropDownHeadline>
                <strong>
                    {t('checkin.accompanying.accompanyingLabel')}
                </strong>
                <p>
                    {t('checkin.accompanying.maxPeople')}: {maxAccompanying} {maxAccompanying === 1 ? t('checkin.accompanying.person') : t('checkin.accompanying.people')}
                </p>
            </S.ContainerDropDownHeadline>
            <S.ContainerDropDown>
                {users.length > 0 ? (
                    <S.ContainerAccompanyingAdd >
                        {users.map((usuario: any, index) => (
                            <S.ContainerContentAccompanying key={index}>
                                <DropdownCheckin
                                    key={index}
                                    {...usuario}
                                >
                                    <S.ActionButtons>
                                        <S.EditButton onClick={() => handleEditAccompanying(index)}>
                                            <img src={editIcon} alt="" />
                                        </S.EditButton>
                                        <S.DeleteButton onClick={() => handleDeleteAccompanying(index)}>
                                            <img src={deleteIcon} alt="" />
                                        </S.DeleteButton>
                                    </S.ActionButtons>
                                </DropdownCheckin>


                            </S.ContainerContentAccompanying>
                        ))}
                    </S.ContainerAccompanyingAdd>
                ) : (
                    <S.NoHasCompanion>
                        <p>{t('checkin.accompanying.noHasCompanion')}</p>
                    </S.NoHasCompanion>
                )}
                {users.length < maxAccompanying &&
                    <S.DropdownContainer onClick={handleAddAccompanying}>
                        <div>
                            <img src={PlusIcon} alt="" width={24} height={24} />
                            <p>
                                {t('checkin.accompanying.buttonAdd')}
                            </p>
                        </div>
                    </S.DropdownContainer>
                }
            </S.ContainerDropDown>
            <FooterWithButtons handleNextStep={handleNextStep} handleBackStep={handleBackStep} />
        </S.AccompanyingContainer >
    )
}